//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { xtLoginJsPath, websocketPath } from '@/config/project-config'
import {commonTool} from "@/util/base"
import {API} from '@/util/api'
import {requestByPost} from "../../util/request";
import {Toast} from "vant";
import {fileutil} from "@/util/fileutil"
import areaCascader from '@/pages/common/areaCascader/areaCascader'
import md5 from "js-md5";
import QRCode from 'qrcodejs2'
import Vue from 'vue'
import websocketService from '@/common/websocket'
Vue.prototype.$socket = websocketService.Instance
export default {
  name: "",
  components: {
    areaCascader
  },
  data () {
    return {
      rzC:1,
      xtLoginJsPath,
      fileutil: fileutil,
      app: null,
      // app: {
      //   id: '-1',
      //   showText: '如果您不是一下任意管理系统用户，请选择我！！',
      //   appName: '非平台·管理系统用户',
      //   appIcon: require('../../assets/images/e61_03.png'),
      //   couldApply: 1
      // },
      applications: [],
      show: 1,
      form: this.$form.createForm(this),
      industrys: [],
      industrysCheck: [],
      image: {},
      second: 10,
      timer: null,
      yzmMsg: '发送验证码',
      timerYzm: null,
      yzmSecond: 60,
      isLogin: false,
      companyId: '',
      nowCheckApp: null,
      allCompanys: [],
      nowCheckCom: {},
      nowFactory: {}
    }
  },
  methods: {
    getAppName (item) {
      const arr = item.appName.split("·")
      return '<img style="width:128px;height:128px;" src='+item.appIcon+' alt="" srcset=""><i style="display: block;text-align: center">'+arr[0]+'</i><i>'+arr[1]+'</i>'
    },
    getAppClass (item) {
      if(item.id == "-1") {
        return "a14"
      }
      return ""
    },
    fnShowModel () {
      if (window.screen.height <= 768 && window.screen.width <= 1366) {
        return 'height:495px !important;overflow-y: auto;'
      } else {
        return 'height:520px !important;overflow-y: auto;'
      }
    },
    fnShowModelFortst () {
      if (window.screen.height <= 768 && window.screen.width <= 1366) {
        return 'height:495px !important;overflow-y: auto;'
      } else {
        return 'height:604px !important;overflow-y: auto;'
      }
    },
    settingHeaders () {
      // 设置验证参数， 用户不校验是否登录调用接口
      let timestamp = new Date().getTime() + '';
      let radom = Math.random() + '';
      let str = timestamp + radom + '1'
      let token = md5(str)
      return { timestamp: timestamp, radom: radom, crossToken: token,crossType: 1 }
    },
    fnInitData () {
      this.initApplications()
      this.initIndustrys()
    },
    initApplications () {
      const param = {}
      param.isHide = 0
      requestByPost(API.queryApplications,JSON.stringify(param), 0, 0, 1).then((res)=>{
        const arr = []
        // arr.push(this.app)
        this.applications = arr.concat(res.data.data)
        this.fnCheckInitApp()
      })
    },
    fnCheckInitApp () {
      if (this.$route.query && this.$route.query.appId) {
        var app = this.applications.find(app => app.id == this.$route.query.appId)
        if (app && app.id) {
          this.fnCheckApp(app)
        }
      }
    },
    fnCheckApp (app) {
      this.rzC = app.id
      if (app.couldApply == 0) {
        this.nowCheckApp = null;
        Toast('暂未开通，敬请期待');
        return
      }
      // 校验是否登录
      this.checkLogin()
      if (app.id == '-1') {
        // 自行入驻
        this.show = 2
      } else {
        // app扫码入驻，创建websocket
        this.nowCheckApp = app
        this.initQrcode()
      }
    },
    //校验点击的入驻类型  0非平台用户入驻  1平台用户入驻
    fnCheckRzType (type) {
      // 校验是否登录
      this.checkLogin()
      if (type == 0) {
        // 自行入驻
        this.show = 2
      } else {
         this.show = 3
        // app扫码入驻，创建websocket
        // this.nowCheckApp = app
        // this.initQrcode()
      }
    },
    initQrcode () {
      // const nowStocketId =
      let timestamp = new Date().getTime() + ''
      let random = Math.random() + ''
      let socketId = md5(this.nowCheckApp.id + timestamp + random)
      const userInfo = JSON.parse(localStorage.getItem("userInfo"))
      const userPhone = this.isLogin?userInfo.userPhone:'-1'
      const obj = "ei"+"@_@" + userPhone + "@_@" + this.nowCheckApp.id + "@_@" + socketId
      this.show = 3
      this.$nextTick(() => {
        const qrcode = new QRCode('qrcode', {
          width: 274,
          height: 274
        })
        qrcode.clear()
        qrcode.makeCode(obj)
        this.$refs.qrcode.title = ""
      })
      this.$socket.nowSocketId = socketId
      this.$socket.init()
    },
    handleCancel () {
      const div = document.getElementById('qrcode')
      div.innerHTML = ''
      this.visible = false
    },
    changeAreaData(value) { // 设置地区的值
      this.form.setFieldsValue({
        area: value
      })
    },
    handleFileChange(info) {
      const status = info.file.status
      if (status === 'done') {
        this.image = info.file.response.obj
        this.$message.success(`${info.file.name} 图片上传成功`)
      } else if (status === 'error') {
        this.$message.error(`${info.file.name} 图片上传失败`)
      }
    },
    beforeUpload(file) {
      return fileutil.beforeUploadOnlyImg(this, file)
    },
    fnClear () {
      clearInterval(this.timerYzm)
      clearInterval(this.timer)
      this.handleCancel()
      this.yzmMsg = '发送验证码'
      this.$socket.clear()
    },
    fnNext(param) {
      this.$socket.clear()
      this.show = param
      if(param == 4) {

      } else if (param == 5) {
        this.fnCloseWindow(1)
      } else if (param == 6) {
        this.fnCloseWindow(1)
      }
    },
    fnBack (param) {
      this.show = param
      if (param == 1) {
        this.fnClear()
        this.fnResetForm()
      } else if (param == 2) {

      } else if (param == 5) {
        // 新建入驻成功，显示倒计时
        this.fnCloseWindow(0)
      }
    },
    fnResetForm () {
      this.form.resetFields()
      
      this.image.url = null
    },
    handleCloseWindow () {
      const state = {companyId: this.companyId}
      this.fnGotoCompanyCenter({state:JSON.stringify(state),second_redirect_uri:'login', self_redirect: '1'},function(){
        // window.close()
      })
    },
    fnCloseWindow (t) {
      let second = this.second
      this.timer = setInterval(() => {
        if (second > 1) {
          second = second - 1
          this.second = second
        } else {
          clearInterval(this.timer)
          if (t == 1) {
            const state = {companyId: this.companyId}
            this.fnGotoCompanyCenter({state:JSON.stringify(state),second_redirect_uri:'login', self_redirect: '1'},function(){
              // window.close()
            })
          }
        }
      }, 1000)
    },
    fnCreateObj (values) {
      const obj = {};
      let groupId= commonTool.generateUUID();
      obj.companyName = values.companyName;
      obj.industry = values.industry
      obj.industryName = this.industrys.find(a => a.itemValue == obj.industry).itemName
      obj.useAppId = this.industrys.find(a => a.itemValue == obj.industry).appId
      obj.country = '中华人民共和国'
      obj.province = values.area.province
      obj.city = values.area.city
      obj.area = values.area.district
      obj.countryCode = '-1'
      obj.provinceCode = values.area.provinceCode
      obj.cityCode = values.area.cityCode
      obj.areaCode = values.area.districtCode
      // obj.address = values.address
      obj.legalPerson = values.legalPerson
      obj.companyLogoGroupId = groupId
      // obj.groupId = groupId
      obj.qualityImage = this.image.url
      obj.bindSaasState = 0
      obj.bindSaasNum = 1
      obj.trialState = 1
      obj.formalState = 0
      obj.expireState = 0
      obj.openState = 0
      obj.rejectState = 1
      obj.aiCertificate = 0;
      obj.openIm = 0;
      // if (this.isLogin) {
      //   const userInfo = JSON.parse(localStorage.getItem("userInfo"))
      //   obj.createUserId = userInfo.id
      //   obj.ucUserId = userInfo.id
      //   obj.ucUserName = userInfo.realName==null?userInfo.nickName:userInfo.realName
      //   obj.ucUserPhone = userInfo.userPhone
      // } else {
        obj.smsPhone = values.userPhone
        obj.smsCode = "nbtest"//内部登录验证码写死为“nbtest”，后台登录接口也判断了，这个验证码直接过，不用向客户索取验证码
        obj.isPrewebCreate = 1;
        obj.userIsLogin = 0;
      // }
      return obj
    },
    fnCreateFileInfoBo(data) {
     
      if(this.image != null && this.image != undefined && this.image.url != null && this.image.url != "" && this.image.url != undefined){
        const obj = {}
        obj.appId = data.useAppId
        obj.groupId = data.companyLogoGroupId
        obj.url = this.image.url
        obj.disLocal = obj.url
        obj.zipUrl = obj.url
        obj.zipDisLocal = obj.url
        obj.fileSource = '00005'//logo
        obj.fixName = this.image.fileType
        obj.fileType = commonTool.getFileType(obj.fixName)
        obj.fileName = this.image.fileName
        obj.userId = data.createUserId
        obj.sort = 1
        obj.isUse = 1
        return obj
      }else{
        return null;
      }
     
    },
    fnSave(values) {
      const obj = this.fnCreateObj(values)
      obj.ccFileInfoBo = this.fnCreateFileInfoBo(obj)
      requestByPost(API.saveCcCompanyInfoNb,JSON.stringify(obj), 0, 0, 1).then((res)=>{
        if (res.data.retCode == 1) {
          Toast("操作成功")
          // this.fnSettingUserInfo(res.data.obj.ucUserBo)
          // this.companyId = res.data.obj.id
          this.fnResetForm()
          // this.fnNext(5)
        } else {
          Toast(res.data.retMsg)
        }
      })
    },
    fnSaveCompany () {
      // const oldIsLogin = this.isLogin
      // const isLogin = this.checkLoginForSave()
      // if (isLogin && !oldIsLogin) {
      //   // 校验当前填写手机号码与登录账号是否一致
      //   this.$confirm({
      //     title: "温馨提示：检测到您已经登录系统，创建的企业将会与当前登录用户进行绑定，是否继续提交",
      //     okText: '提交',
      //     cancelText: '取消',
      //     onOk: () => {
      //       this.isLogin = isLogin
      //       this.form.validateFields((error, values) => {
      //         this.fnSave(values)
      //       })
      //     }
      //   });
      // }
      this.form.validateFields((error, values) => {
        if (!error) {
          // if(!isLogin && !(values.userPhone && values.smsCode)) {
          //   Toast('检测到您已失去登录，请输入手机号和验证码')
          //   this.isLogin = isLogin
          //   return
          // }
          this.fnSave(values)
        }
      });
    },
    fnSettingUserInfo(ucUserBo) {
      this.$store.commit('setUserInfo',ucUserBo)
      this.$store.commit('setToken',ucUserBo.token)
      this.$nextTick(()=>{
        localStorage.setItem('alreadyLogin', 'alreadyLogin' + new Date().getTime() + '')
      })
    },
    initIndustrys () {
      const obj = {}
      obj.dictId = 'industry'
      requestByPost(API.querySysDictItemByDictId,JSON.stringify(obj), 0, 0, 1).then((res)=>{
        this.industrys = res.data.data
        this.industrysCheck = res.data.data
      })
    },
    fnHandleTimer() {
      let second = this.yzmSecond
      this.timerYzm = setInterval(() => {
        if (second > 1) {
          second = second - 1
          this.yzmMsg = second
        } else {
          this.yzmMsg = '发送验证码'
          clearInterval(this.timerYzm)
        }
      }, 1000)
    },
    fnSendYzm () {
      const userPhone = this.$refs.userPhone.value
      if(userPhone == '' || userPhone==undefined){
        Toast('请输入手机号码')
        return
      }

      let mobile = /^((13|14|15|17|18|19)[0-9]{1}\d{8})$/
      if (!mobile.test(userPhone)) {
        Toast('请输入正确的手机号码')
        return
      }

      let param = {
        smsType: 0,
        smsPhone: userPhone
      }
      this.$store.dispatch('fnNoCheckSmsSendSmsCode',JSON.stringify(param)).then(res=>{
        console.log('---------',res);
        if(res.data.retCode == 1){
          this.fnHandleTimer()
        }else{
          Toast(res.data.retMsg)
        }
      })
    },
    checkLogin () {
      let isLogin = true
      const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {}
      if (userInfo == null || userInfo == '' || JSON.stringify(userInfo) == '{}') {
        isLogin = false
      }
      this.isLogin = isLogin
    },
    checkLoginForSave () {
      let isLogin = true
      const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {}
      if (userInfo == null || userInfo == '' || JSON.stringify(userInfo) == '{}') {
        isLogin = false
      }
      return isLogin
    },
    changeCheckCom (value) {
      const com = this.allCompanys.find(a => a.id == value)
      this.nowCheckCom = com
    },
    confirmBind (item) {
      const obj = {}
      obj.applicationBinding = this.nowFactory
      obj.ccCompanyBo = item;
      obj.ucUserBo = JSON.parse(this.nowFactory.ucUserBoStr);
      requestByPost(API.companyBindSaas,JSON.stringify(obj), 0, 0, 1).then((res)=>{
        if(res.data.retCode == 1) {
          this.companyId = item.id
          this.checkLogin()
          // if(!this.isLogin) {
          //   this.fnSettingUserInfo(JSON.stringify(res.data.obj.ucUserBo))
          // }
          this.fnNext(6)
        } else {
          Toast(res.data.retMsg)
        }
      })
    },
    listenerLogin() {
      const _this = this;
      window.addEventListener("storage", function (e) {
        if (e.key && e.key == "alreadyLogin" && e.newValue) {
          _this.userInfo = JSON.parse(localStorage.getItem("userInfo"))
          if (_this.userInfo == null || _this.userInfo == '' || JSON.stringify(_this.userInfo) == '{}') {
            _this.isLogin = false
          } else {
            _this.isLogin = true
          }
        }
      });
    },
    goFirstPage () {
      this.$router.push({path: '/'})
    },
    fnClosePage (){
      this.goFirstPage()
    }
  },
  created() {
    this.checkLogin()
    this.fnInitData()
  },
  mounted() {
    // this.listenerLogin();
    this.$socket.clear()
  },
  computed: {
    message() {
      return this.$store.state.webSocketMsg
    }
  },
  watch: {
    message(data, val) {
      this.checkLogin()
      const obj = JSON.parse(data.data)
      if(!this.isLogin) {
        this.fnSettingUserInfo(JSON.parse(obj.obj.ucUserBoStr))
      }
      if(obj.msgType=="nopass") {
        Toast(obj.msg)
      } else if (obj.msgType == "bindSuccess") {
        Toast(obj.msg)
        this.companyId = obj.obj.ccCompanyId
        this.fnNext(6)
      } else if(obj.msgType == "checkComs") {
        this.allCompanys = JSON.parse(obj.obj.ccCompanyStr)
        this.nowFactory = obj.obj
        //需要选择企业进行绑定
        this.fnNext(4)
      } else if (obj.msgType == "success") {
        this.companyId = obj.obj.ccCompanyId
        this.fnNext(5)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/enterprise/quickEnterInNew.vue